import { render, staticRenderFns } from "./ModalDeleteEventTraining.vue?vue&type=template&id=767d338e&"
import script from "./ModalDeleteEventTraining.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteEventTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports